export default __webpack_public_path__ + "e84109107d9216cb348d8932ecb3f19a.svg";